import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import InfoIcon from '@atlaskit/icon/glyph/info';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { B50, B500, G50, G500, P50, P500, R50, R500, Y50, Y500 } from '@atlaskit/theme/colors';
export const appearanceIconSchema = {
  information: {
    backgroundColor: `var(--ds-background-subtleBrand-resting, ${B50})`,
    Icon: InfoIcon,
    primaryIconColor: `var(--ds-iconBorder-brand, ${B500})`
  },
  warning: {
    backgroundColor: `var(--ds-background-subtleWarning-resting, ${Y50})`,
    Icon: WarningIcon,
    primaryIconColor: `var(--ds-iconBorder-warning, ${Y500})`
  },
  error: {
    backgroundColor: `var(--ds-background-subtleDanger-resting, ${R50})`,
    Icon: ErrorIcon,
    primaryIconColor: `var(--ds-iconBorder-danger, ${R500})`
  },
  success: {
    backgroundColor: `var(--ds-background-subtleSuccess-resting, ${G50})`,
    Icon: CheckCircleIcon,
    primaryIconColor: `var(--ds-iconBorder-success, ${G500})`
  },
  discovery: {
    backgroundColor: `var(--ds-background-subtleDiscovery-resting, ${P50})`,
    Icon: QuestionCircleIcon,
    primaryIconColor: `var(--ds-iconBorder-discovery, ${P500})`
  }
};
export function getAppearanceIconStyles(appearance, icon) {
  const appearanceIconStyles = appearanceIconSchema[appearance] || appearanceIconSchema.information;
  const Icon = icon || appearanceIconStyles.Icon;
  return { ...appearanceIconStyles,
    Icon
  };
}